// extracted by mini-css-extract-plugin
export default {"editButton":"fixedDeduction_editButton__joEdr","TableBody":"fixedDeduction_TableBody__w4o6i","deleteButton":"fixedDeduction_deleteButton__aMZud"};